import {
	monthShortFormatter,
	yearNumericFormatter,
} from '@dop/shared/helpers/dateTimeFormatters';
import { WebAPICBSPeriodType } from '../../../globals/webApiTypes/elements/WebAPICBS';

export const periodTickFormatter = ({
	periodType,
	singleLineWithYear = false,
}: {
	periodType: WebAPICBSPeriodType;
	singleLineWithYear?: boolean;
}) => {
	switch (periodType) {
		case 'Maanden':
			return (date: Date, index: number, dateList: Array<Date>) => {
				const month = monthShortFormatter.format(date);
				const year = yearNumericFormatter.format(date);

				if (singleLineWithYear) return `${month}. ${year}`;

				// First / last tick always show month + year
				if (index === 0 || index === dateList.length - 1)
					return `${month}.\n${year}`;

				const currentYear = date.getFullYear();
				const previousYear = dateList[index - 1].getFullYear();

				// Show month + year when previous year was something different
				if (currentYear !== previousYear) return `${month}.\n${year}`;

				// Otherwise, just show the month without year
				return `${month}.`;
			};
		case 'Kwartalen': {
			// Quarter always returns double line (with year)
			return (date: Date) => {
				const year = yearNumericFormatter.format(date);
				const quarter = Math.floor(date.getMonth() / 3) + 1;

				if (singleLineWithYear) return `Q${quarter} ${year}`;

				return `Q${quarter}\n${year}`;
			};
		}
		case 'Jaar':
			// Year always returns single line
			return (date: Date) => yearNumericFormatter.format(date);
	}
};
